"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PausableUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _PausableUpgradeable__factory.PausableUpgradeable__factory;
  }
});

var _PausableUpgradeable__factory = require("./PausableUpgradeable__factory");